import { PlusIcon } from "lucide-react";
import { Button } from "@/components/Button/Button";
import { UserJobButton } from "@/components/Sidebar/UserJobs/UserJobButton";
import { AppText } from "@/components/Text/AppText";
import { IUserJob } from "@/types/userJob";

interface UserJobsButtonGroupProps {
    setLinkedJobId: (jobId: string) => void;
    onEditJob: (jobId: string) => void;
    userJobs: IUserJob[];
    resumeJobId: string;
    onCreateJob: () => void;
}

export const UserJobsButtonGroup = ({
    setLinkedJobId,
    onEditJob,
    userJobs,
    resumeJobId,
    onCreateJob,
}: UserJobsButtonGroupProps) => (
    <div className="flex h-full flex-col gap-3">
        <div className="flex items-center justify-between">
            <AppText
                variant="contextheading"
                className="text-neutral-700"
            >
                Your Jobs
            </AppText>
            <Button
                size="small"
                leftIcon={<PlusIcon size={16} />}
                onClick={onCreateJob}
            >
                Add Job
            </Button>
        </div>
        <div className="no-scrollbar min-h-0 flex-1 overflow-y-auto">
            <div className="flex flex-col gap-2 pb-10">
                {userJobs.length === 0 && (
                    <div className="mt-4 flex flex-col items-center justify-center gap-4 p-2">
                        <AppText
                            variant="labelsbuttons"
                            className="text-center text-neutral-500"
                        >
                            No jobs created yet.
                        </AppText>
                        <AppText
                            variant="labelsbuttons"
                            className="text-center text-neutral-500"
                        >
                            1Template jobs let you track jobs you apply for,
                            manage attached resumes, and tailor resumes to your
                            jobs.
                        </AppText>
                    </div>
                )}
                {userJobs.map(job => (
                    <UserJobButton
                        key={job.id}
                        job={job}
                        isActive={resumeJobId === job.id}
                        setLinkedJobId={() => setLinkedJobId(job.id)}
                        onEditJob={() => onEditJob(job.id)}
                    />
                ))}
            </div>
        </div>
    </div>
);
